var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.results)?_c('div',{class:_vm.containerClass,attrs:{"id":_vm.containerName}},[_c('canvas',{staticStyle:{"z-index":"99999"},attrs:{"id":_vm.canvasName}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }